import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import toast from 'react-hot-toast';
import {AiFillDelete, AiFillEdit} from 'react-icons/ai';
import {useNavigate} from 'react-router-dom';

import CustomTable from '../components/common/CustomTable';
import InputField from '../components/ui/InputField';
import AlertModal from '../components/AlertModal';
import Button from '../components/ui/Button';
import AddSubjectModal from '../components/Test/AddSubjectModal';
import {
  useDeleteSubjectMutation,
  useGetSubjectsQuery,
} from '../api/candidateTest';
import {isEmpty} from 'lodash';

const ManageSubject = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    sort: null,
    sortBy: null,
    page: 1,
    limit: 10,
  });
  const [subjectModal, setSubjectModal] = useState(false);
  const [deleteSubject, setDeleteSubject] = useState(null);

  const {
    mutate: removeDeleteSubjectMutation,
    isLoading: isDeleteSubjectLoading,
  } = useDeleteSubjectMutation();

  const {
    data: subjectData,
    isFetching: isSubjectLoading,
    refetch,
    error,
  } = useGetSubjectsQuery(formData);

  const {
    subjectData: allSubjects,
    totalItems = null,
    totalPages = null,
  } = subjectData?.data || {subjectData: []};

  useEffect(() => {
    if (!isSubjectLoading && !allSubjects.length && !error) {
      setFormData((prev) => ({
        ...prev,
        page: prev.page === 1 ? 1 : prev.page - 1,
      }));
    }
  }, [subjectData]);

  // form management
  const {handleSubmit, watch, register} = useForm({
    mode: 'all',
  });

  const handleFormSubmission = async (values) => {
    const {search, job, stage} = values;
    let payload = {search};

    if (job?.value) payload = {...payload, job: job.value};
    if (stage?.value) payload = {...payload, stage: stage.value};

    // set pagination to page 1
    setFormData((prev) => ({
      ...prev,
      ...payload,
      page: 1,
    }));
  };

  useEffect(() => {
    const subscription = watch(handleSubmit(handleFormSubmission));
    return () => subscription.unsubscribe();
  }, [handleSubmit, watch]);

  const handleDeleteSubject = (subjectId) => {
    removeDeleteSubjectMutation(subjectId, {
      onSuccess: () => {
        setDeleteSubject(null);
        toast.success('Subject successfully removed.');
        refetch();
      },
      onError: (data) =>
        toast.error(data.response.data.message || 'something went wrong'),
    });
  };

  const handleSort = (sortingDetails) => {
    const {page = null, sortBy, sortDirection = null} = sortingDetails;
    setFormData((prevFormData) => ({
      ...prevFormData,
      page: page || prevFormData.page,
      sortBy,
      sort: sortDirection,
    }));
  };

  const tHeadData = [
    {
      id: 2,
      keyIndex: 'subject',
      label: 'Subject',
      sort: true,
      width: '20%',
    },
    {
      id: 3,
      keyIndex: 'compiler',
      label: 'compiler',
      sort: true,
      render: (item) => item?.name || '-',
      // if (!isEmpty(items)) {
      // console.log('items', item?.name)
      //   const compiler = items.map((item) => item?.name);
      //   return compiler.toString();
      // }
      // return '-';
      // },
      width: '30%',
    },

    {
      id: 5,
      keyIndex: 'testQuestionCount',
      label: 'Test question count',
      render: (item) => item || '-',
      width: '25%',
    },
    {
      id: 6,
      keyIndex: 'testTime',
      label: 'Test Duration',
      sort: true,
      width: '25%',
      render: (item) => (item ? `${item} min` : '-'),
    },
    {
      id: 7,
      keyIndex: '_id',
      label: 'Action',
      width: '25%',
      render: (_id, itemDetails) => (
        <div className="flex gap-2">
          <button onClick={() => setSubjectModal(itemDetails)}>
            <AiFillEdit size={20} />
          </button>
          <button
            type="button"
            aria-label="remove candidate from job"
            onClick={() => setDeleteSubject(_id)}
          >
            <AiFillDelete size={20} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {subjectModal && (
        <AddSubjectModal
          isOpen={subjectModal}
          onClose={() => setSubjectModal(false)}
          title={
            typeof subjectModal === 'object'
              ? `Update Subject - ${subjectModal.subject}`
              : 'Add Subject'
          }
          subjectDetails={subjectModal}
          width="lg"
          editMode={typeof subjectModal === 'object'}
          refetch={refetch}
        />
      )}

      <AlertModal
        type="warning"
        isOpen={deleteSubject}
        onClose={() => setDeleteSubject(null)}
        title="Confirm this action"
        onCancel={() => setDeleteSubject(null)}
        onOK={() => handleDeleteSubject(deleteSubject)}
        okLoading={isDeleteSubjectLoading}
      >
        Are you sure you want to delete this subject?
      </AlertModal>

      <div className="px-8 py-6">
        <div className="flex items-center gap-2">
          <h3 className="text-2xl font-bold">
            Subjects {!!Number(totalItems) && `(${totalItems})`}
          </h3>
        </div>
        <form className="py-5">
          <div className="flex justify-between">
            <div className="flex gap-4">
              <InputField
                {...register('search')}
                type="search"
                placeholder="Search"
                className="w-60"
              />
            </div>

            <div className="flex items-center gap-3">
              <Button
                className="py-3 px-5"
                onClick={() => setSubjectModal(true)}
              >
                Add Subject
              </Button>
              <Button
                className="py-3 px-5"
                onClick={() => navigate('/questions')}
              >
                Go to Questions
              </Button>
            </div>
          </div>
        </form>

        <div className="bg-[white] p-10 border">
          <CustomTable
            tHeadData={tHeadData}
            tBodyData={allSubjects}
            handleSort={handleSort}
            pageCount={totalPages}
            currentPage={formData.page}
            loading={isSubjectLoading}
          />
        </div>
      </div>
    </>
  );
};

export default ManageSubject;
